// NOTE: Object.keysの型推論が効かないため
const getKeys = <T extends { [key: string]: unknown }>(obj: T): (keyof T)[] =>
  Object.keys(obj);

export default getKeys;
